export default "__VITE_ASSET__CvSOFHJX__"